import { StatusCodes } from 'http-status-codes';
import React, { useState } from 'react';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import FnbApi from '~/src/services/api/FnbApi';

interface Props {
  dataItemId: string;
  onUpdate?: () => void;
}
export default function CompleteFnbOrder({ dataItemId, onUpdate }: Props): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [resultMessage, setResultMessage] = useState<string | null>(null);

  const markAsCompleteBoth = async (skipInvoice: boolean): Promise<void> => {
    setLoading(true);
    var res = await FnbApi.markAsComplete(dataItemId, skipInvoice);
    if (res.status === StatusCodes.OK) {
      if (res.data.result) {
        if (onUpdate) {
          onUpdate();
        }
      } else {
        setResultMessage(res.data.message)
      }
    }
    // setNewData(dataItemId);
    // newData = dataItemId;
    setLoading(false);
  };

  return (
    <>
      <PrimaryButton
        title="Complete"
        onClick={async (): Promise<void> => {
          await markAsCompleteBoth(false);
        }}
        // {...rest}
        isSubmitting={loading}
        size="sm"
      />
      <SecondaryButton
        title="Complete no Inv"
        onClick={async (): Promise<void> => {
          await markAsCompleteBoth(true);
        }}
        // {...rest}
        isSubmitting={loading}
        size="sm"
      />
      {resultMessage && (
        <div>
          {resultMessage}
        </div>
      )}
    </>
  );
}
